import React, { FC } from 'react';
import { ApprovalModalOcnPriorityProps } from './ApprovalModalOCNPriorityProps';
import { Stack } from '@mui/material';
import SkappaCompleteSelect from '../SkappaCompleteSelect';
import useTranslation from '../../hooks/useTranslation';
import Text from '@ingka/text';
import { OCNOptions } from './utils';
const ApprovalModalOcnPriority: FC<ApprovalModalOcnPriorityProps> = ({
  ocnPriority,
  setOcnPriority,
}) => {
  const t = useTranslation();

  return (
    <Stack>
      <Text style={{ fontWeight: '700' }}>{t('common.OCNPriority')}</Text>
      <Text>
        <span>{t('ppm.OCN.description')}</span>
      </Text>
      <Stack mt={2}>
        <SkappaCompleteSelect
          value={ocnPriority}
          label={t('common.OCNPriority')}
          id={`OCN-priority-select`}
          onChange={setOcnPriority}
          options={OCNOptions}
        />
      </Stack>
    </Stack>
  );
};

export default ApprovalModalOcnPriority;
